import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable, of} from "rxjs";
import {map} from "rxjs/operators";
import { AppService } from '@irb/app.service';

@Injectable({
    providedIn: 'root'
})
export class IrbMMCSettingsService {
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
        })
    };
    mmcServiceUrlPrefix = '/mmc';


    constructor(
        private _http: HttpClient,private as: AppService
    ) {
        const useModelMarketService = this.as.getItem('IRB_APP_CONFIG')?.featureFlags?.ENABLE_MMC_APIS || false;
        if (useModelMarketService)
            this.mmcServiceUrlPrefix = '/model-market-service';
    }


    getModelMarketSettings() {
        const url = `/model-market-service/settings/get-model-market-settings`;
        return this._http.get(url, this.httpOptions).pipe(map(res => this.defineResponse(res)));
    }

    validateMMCSetting(settingId: any, settingType: any) {
        const url = `/model-market-service/settings/validate-mmc-setting/${settingId}/${settingType}`;
        return this._http.get(url, this.httpOptions).pipe(map(res => this.defineResponse(res)));
    }

    saveMMCSetting(mmcGlobalSettings: any): Observable<Object> {
        return this._http.post("/model-market-service/settings/save-mmc-settings", JSON.stringify(mmcGlobalSettings), this.httpOptions).pipe(map(res => this.defineResponse(res)));
    }
    getModelMarketNotifications() {
        const url = `/model-market-service/settings/get-model-market-notifications`;
        return this._http.get(url, this.httpOptions).pipe(map(res => this.defineResponse(res)));
    }
    getModelProviders() {
        let url = `${this.mmcServiceUrlPrefix}/get-model-providers`;
        return this._http.get(url, this.httpOptions).pipe(map(res => this.defineResponse(res)));
    }
    getModelMarketProviderModels(modelProviderId: any) {
        let url = `${this.mmcServiceUrlPrefix}/get-model-market-provider-models/${modelProviderId}`;
        return this._http.get(url, this.httpOptions).pipe(map(res => this.defineResponse(res)));
    }
    saveModelMarketNotifications(mmcNotes: any[]) {
        const url = `/model-market-service/settings/save-model-market-notifications`;
        return this._http.post(url, JSON.stringify(mmcNotes), this.httpOptions).pipe(map(res => this.defineResponse(res)));
    }

    resetUserAgreement(): Observable<Object> {
        const url = `/model-market-service/reset-user-terms-conditions`;
        return this._http.put(url, this.httpOptions).pipe(map(res => this.defineResponse(res)));
        //return of(true)
    }

    getMMCTCInfo() {
        let url = `/model-market-service/user-tc-reset-date`;
        return this._http.get(url, this.httpOptions).pipe(map(res => this.defineResponse(res)));

        //return of({"mmcTCId": 25,"mmcTCResetDate": 1732269235124,"userId": 13205764})
    }

    defineResponse(res: any) {
        return  res && res.data && res.data.irebalResponse ? res.data.irebalResponse : res;
    }

    getMMCReportRequests(): Observable<Object> {
        return this._http.get("/model-market-service/report-request", this.httpOptions).pipe(map(res => this.defineResponse(res)));
    }

    deleteMMCReportRequest(reportId: number): Observable<Object> {
        return this._http.delete("/model-market-service/report-request/" + reportId, this.httpOptions);
    }

    updateMMCReportRequests(reportId: number, updatedData: any): Observable<Object> {
        return this._http.put("/model-market-service/report-request/" + reportId, updatedData, this.httpOptions).pipe(map(res => this.defineResponse(res)));
    }

    addMMCReportRequests(newData: any): Observable<Object> {
        return this._http.post("/model-market-service/report-request", newData, this.httpOptions).pipe(map(res => this.defineResponse(res)));
    }
}
